import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { TextBox, TextBoxComponentSpacing, TextBoxLayoutStyle } from './TextBox';
import { FocusInEvent } from 'devextreme/ui/text_box';

interface CvcBoxProps {
    id?: string;
    dataTestid?: string;
    value: string | undefined;
    name?: string;
    readOnly?: boolean;
    disabled?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onFocusIn?: ((e: FocusInEvent) => void) | undefined;
    onValidationEvent?: (isValid: boolean) => void;
    componentSpacing?: TextBoxComponentSpacing;
    showInfoIcon?: boolean;
    infoText?: ReactNode;
    /** Label above the input (Vertical, default) or beside it (Horizontal). */
    layoutStyle?: TextBoxLayoutStyle;
    /** Label column width when layoutStyle is Horizontal. Defaults to 120px. */
    labelWidth?: string;
    /** Total height of the input box, border included (e.g. '36px'). Omit to keep the default height. */
    height?: string;
}

export const CvcBox: React.FC<CvcBoxProps> = ({
    id,
    dataTestid,
    value,
    readOnly = false,
    disabled = false,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    onChange,
    onEnterKey,
    onFocusIn,
    onValidationEvent,
    componentSpacing,
    showInfoIcon = false,
    infoText,
    layoutStyle,
    labelWidth,
    height,
}) => {
    const [currentValue, set_currentValue] = useState(value);

    const validateValue = (value: string) => {
        if (!value) return false;

        return true;
    };

    useEffect(() => {
        if (!value) return;

        set_currentValue(value);
    }, [value]);

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            value={currentValue}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            onChange={onChange}
            onFocusIn={onFocusIn}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            maxLength={maxLength}
            type='text'
            mask='000'
            maskChar='•'
            maskInvalidMessage='Invalid month and year'
            componentSpacing={componentSpacing}
            disabled={disabled}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            layoutStyle={layoutStyle}
            labelWidth={labelWidth}
            height={height}
        />
    );
};
